import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftComplianceRecordingPolicyFieldConfig,
  MicrosoftDubberPointsFieldConfig,
  MicrosoftDubberUserFieldConfig,
} from '../models/generated/ziroModels';

@Injectable()
export class DubberFieldConfigResource {
  protected http = inject(HttpClient);

  getComplianceRecordingPolicy(
    tenantId: string | number,
    withRecording: boolean,
  ): Observable<MicrosoftComplianceRecordingPolicyFieldConfig> {
    return this.http.get<MicrosoftComplianceRecordingPolicyFieldConfig>(
      `/services/microsoft/field-config/tenants/${tenantId}/compliance-recording-policies?withRecording=${withRecording}`,
    );
  }

  getDubberUserFieldConfig(tenantId: string | number, upn: string): Observable<MicrosoftDubberUserFieldConfig> {
    return this.http.get<MicrosoftDubberUserFieldConfig>(
      `/services/microsoft/field-config/tenants/${tenantId}/dubber-users?upn=${encodeURIComponent(upn)}`,
    );
  }

  getDubberPointsFieldConfig(tenantId: string | number): Observable<MicrosoftDubberPointsFieldConfig> {
    return this.http.get<MicrosoftDubberPointsFieldConfig>(
      `/services/microsoft/field-config/tenants/${tenantId}/dub-points`,
    );
  }
}
